export default "__VITE_ASSET__CrDEayKr__"